import { z } from "zod";

const coordinateError = { error: "location.invalidCoordinates" };
export const coordinateFields = {
	latitude: z
		.number(coordinateError)
		.min(-90, coordinateError)
		.max(90, coordinateError)
		.nullable()
		.optional(),
	longitude: z
		.number(coordinateError)
		.min(-180, coordinateError)
		.max(180, coordinateError)
		.nullable()
		.optional(),
};
export function validateCoordinatePair(
	value: { latitude?: number | null; longitude?: number | null },
	context: z.RefinementCtx,
) {
	if ((value.latitude == null) !== (value.longitude == null)) {
		context.addIssue({
			code: "custom",
			message: "location.coordinatesRequired",
			path: [value.latitude == null ? "latitude" : "longitude"],
		});
	}
}
